import { withInstall } from '@vuesax-plus/utils'
import Avatar from './src/avatar.vue'

export const VsAvatar = withInstall(Avatar)
export default VsAvatar

export * from './src/avatar'
